export default __webpack_public_path__ + "static/media/data-table.be7961ad.png";